<template>
  <div
    class="event-card p-3 mb-4 d-flex"
    :class="[owner, isPastEvent ? 'past-event' : '']"
  >
    <div class="event-card__date me-4 pe-3 py-2">
      <div class="date" v-text="formatDate(event.date.start)" />
      <div class="time" v-text="formatTime(event.date.start)" />
    </div>
    <div class="event-card__meta py-1">
      <div class="categories">
        <span
          v-for="(cat, index) in event.types"
          :key="index"
          class="category-badge"
          v-text="cat.name"
        />
      </div>
      <a
        v-if="event.link && event.title"
        :href="event.link"
        class="event-card__meta__link"
      >
        <h3 class="event-card__meta__title" v-text="event.title" />
      </a>
      <h3 v-else class="event-card__meta__title" v-text="event.title" />
    </div>
  </div>
</template>

<script>
import { format, isPast } from 'date-fns';
import { uk } from 'date-fns/locale';

export default {
  props: {
    event: Object,
    owner: {
      type: String,
      default: '',
    },
  },
  methods: {
    formatDate: date => format(new Date(date), 'PP', { locale: uk }),
    formatTime: date => format(new Date(date), 'p', { locale: uk }),
  },
  computed: {
    isPastEvent() {
      return isPast(new Date(this.event.date.end));
    },
  },
};
</script>
